import ServiceOutage from './ServiceOutage';

export default ServiceOutage;
